const minxin = {
    methods: {
        getHomeImageUrl(img) {
            // return this.$homeImgUrl + img;
        },
        getOtherImageUrl(img) {
            return this.$imgUrl + img;
        }
    }
}

export default minxin;